import { render } from "./GeneralLedger.vue?vue&type=template&id=5389aae0&scoped=true"
import script from "./GeneralLedger.vue?vue&type=script&lang=js"
export * from "./GeneralLedger.vue?vue&type=script&lang=js"

import "./GeneralLedger.vue?vue&type=style&index=0&id=5389aae0&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5389aae0"]])

export default __exports__